import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

Vue.use(Router);

export function importComponent(path) {
  return () => {
    store.commit('app/setLoading', true);
    return import(`@/components/${path}`).then(
      (data) => {
        store.commit('app/setLoading', false);
        return data;
      },
      (reject) => {
        store.commit('app/setLoading', false);
        return reject;
      },
    );
  };
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/Paramètres',
      name: 'Parameters',
      component: importComponent('parameters/Parameters'),
    },
    {
      path: '/TachesRegulieres',
      name: 'RegularTasks',
      component: importComponent('tasks/RegularTasks'),
    },
    {
      path: '/Projets',
      name: 'Projects',
      component: importComponent('projects/Projects'),
    },
    {
      path: '/Projet',
      name: 'Project',
      component: importComponent('projects/Project'),
    },
    {
      path: '/Resume',
      name: 'Resume',
      component: importComponent('resume/Resume'),
    },
    {
      path: '/Individus',
      name: 'Workers',
      component: importComponent('workers/Workers'),
    },
    {
      path: '/ProjetDetails',
      name: 'ProjectDetails',
      component: importComponent('projects/ProjectDetails'),
    },
  ],
});
